"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return _defineProperty({
    messageWrapper: {
      padding: 24
    },
    heading: {
      marginBottom: 16
    },
    backLink: {
      display: 'inline-block',
      marginTop: 32
    }
  }, theme.breakpoints.up('sm'), {
    messageWrapper: {
      padding: 48
    }
  });
};

var NotFoundPage = function NotFoundPage(_ref2) {
  var t = _ref2.t;
  var classes = {};
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.messageWrapper
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "display1",
    className: classes.heading
  }, 'notFoundPage.heading'), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "subheading"
  }, 'notFoundPage.subheading'), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/",
    className: classes.backLink
  }, 'notFoundPage.backLink'));
};

NotFoundPage.propTypes = {
  t: _propTypes["default"].func.isRequired
}; // prettier-ignore

var _default = NotFoundPage;
exports["default"] = _default;